export const userLeftTheField = (): boolean => document.hasFocus()
